var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddGifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 8.48V6.78H12.7V13.18H14.4V11.18H16.4V9.48H14.4V8.48H17.1ZM9.8 6.78H11.5V13.18H9.8V6.78ZM6.2 8.38C6.6 8.38 7.1 8.58 7.4 8.88L8.6 7.88C8 7.18 7.1 6.78 6.2 6.78C4.4 6.78 3 8.18 3 9.98C3 11.78 4.4 13.18 6.2 13.18C7.2 13.18 8 12.78 8.6 12.08V9.58H5.8V10.78H7V11.38C6.8 11.48 6.5 11.58 6.2 11.58C5.3 11.58 4.6 10.88 4.6 9.98C4.6 9.18 5.3 8.38 6.2 8.38Z",
    fill: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.907 0H2.09302C0.939535 0 0 1.007 0 2.247V17.754C0 18.992 0.939535 20 2.09302 20H17.907C19.0605 20 20 18.992 20 17.754V2.247C20 1.007 19.0605 0 17.907 0ZM18.6047 17.754C18.6047 18.164 18.2921 18.5 17.907 18.5H2.09302C1.70791 18.5 1.39535 18.164 1.39535 17.754V2.247C1.39535 1.835 1.70791 1.5 2.09302 1.5H17.907C18.2921 1.5 18.6047 1.835 18.6047 2.247V17.754Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGifIcon);
export default __webpack_public_path__ + "static/media/addGIFIcon.eeb7201ab2bcc9eb5c678c2bda94b747.svg";
export { ForwardRef as ReactComponent };